import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  .ant-table-header {
    display: none !important;
  }

  .ant-table-cell {
    border-radius: 8px !important;
  }

  .card-title-right {
    display: none !important;
  }
`;

export const TimelineContainer = styled.div`
  position: relative;
  margin-top: 20px;
  width: 100%;
`;

export const TimelineSection = styled.div`
  margin-bottom: 20px;
`;

export const TimelineTitle = styled.div`
  font-size: 18px;
  text-align: center;
  margin-bottom: 30px;
`;

export const TimelineControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .previous-timeline-button,
  .next-timeline-button {
    color: ${({ theme }) => (theme.title === 'dark' ? '#F0F5F5' : '#646E6E')};
  }
`;

export const TimelineContent = styled.div`
  flex: 1;
  position: relative;
`;

export const DateLabelsContainer = styled.div`
  position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 0;
  font-size: 12px;
  z-index: 10;

  &.single-period {
    display: block;
    text-align: center;

    @media (max-width: 768px) {
      .label-desktop {
        display: inline !important;
      }
    }
  }

  .label-mobile {
    display: none;
  }
  .label-desktop {
    display: inline;
  }

  @media (max-width: 768px) {
    .label-mobile {
      display: inline;
    }
    .label-desktop {
      display: none;
    }
  }
`;

export const DateLabel = styled.div`
  text-align: center;
`;

export const TimelineBars = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 1px;
  height: 32px;

  &.single-period {
    display: block;
  }
`;

export const TimelineBar = styled.div<{ isLast: boolean }>`
  height: 32px;
  background-color: #239687;
  position: relative;

  &.single-period {
    width: 100%;
  }
`;

export const EventIndicator = styled.div<{
  startPosition: number;
  width: number;
}>`
  position: absolute;
  top: 0;
  height: 32px;
  left: ${props => `${props.startPosition}%`};
  width: ${props => `${props.width}%`};
  display: flex;
  align-items: center;
  pointer-events: none;

  .anticon-close-circle {
    background-color: transparent !important;
  }
`;

export const EventIcon = styled.div<{ type: string }>`
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background-color: ${props =>
    props.type === 'outage' ? '#f5222d' : '#fa8c16'};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
`;

export const MousePositionIndicator = styled.div<{ x: number }>`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: black;
  pointer-events: none;
  left: ${props => `${props.x}px`};
`;

export const EventsListSection = styled.div`
  margin-top: 30px;

  .ant-collapse-expand-icon{
    color: ${({ theme }) => theme.colors.text};
  }

  .anticon-close-circle{
    background-color: transparent !important;
  }

  .ant-collapse{
    background-color : ${({ theme }) =>
      theme.title === 'dark' ? 'transparent' : '#fafafa'};
    border: ${({ theme }) => `1px solid ${theme.colors.border}`};
  }
  
  .ant-collapse-content {
    border-top: ${({ theme }) => `1px solid ${theme.colors.border}`};
  }

  .ant-collapse > .ant-collapse-item:last-child, .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
    border-radius: 8px;
  }

  .ant-collapse > .ant-collapse-item:last-child, .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header:hover {
    border-radius: 0 0 8px 8px;
  }

  .ant-collapse > .ant-collapse-item {
    border-bottom: ${({ theme }) => `1px solid ${theme.colors.border}`};
  }

  .ant-collapse > .ant-collapse-item:last-child {
    border-bottom: none;
  }

  .ant-collapse > .ant-collapse-item > .ant-collapse-header{
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .ant-collapse > .ant-collapse-item > .ant-collapse-header:hover{
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }

  .ant-collapse > .ant-collapse-item:first-child > .ant-collapse-header:hover {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }

  .ant-collapse-header {
    background-color: ${({ theme }) => theme.colors.background};
  }

  .ant-collapse-header:hover {
    background-color: ${({ theme }) => theme.colors.content1};
  }

  .ant-collapse-header[aria-expanded="true"] {
    background-color: ${({ theme }) => theme.colors.background1};
    color: ${({ theme }) => theme.colors.text};
  }

  .ant-collapse-header-text{
    color: ${({ theme }) => theme.colors.text};
  }

  .ant-collapse-content-box{
    background-color: ${({ theme }) => theme.colors.content};
  }
  
  .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-content > .ant-collapse-content-box {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .ant-collapse > .ant-collapse-item:only-child > .ant-collapse-content > .ant-collapse-content-box {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .disabled-collapse .ant-collapse-header {
    cursor: default !important;
  }
}

`;

export const EventsListTitle = styled.h4`
  margin-bottom: 16px;
`;

export const EventsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const EventItem = styled.div`
  padding: 12px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const EventIconContainer = styled.div`
  margin-top: 4px;
`;

export const EventContent = styled.div``;

export const EventTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 4px;
`;

export const EventId = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
`;

export const EventDate = styled.div`
  font-size: 14px;
  color: #8c8c8c;
`;

export const EventType = styled.div`
  font-size: 14px;
`;

export const EventTypeTag = styled.span<{ type: string }>`
  padding: 2px 8px;
  border-radius: 8px;
  color: ${props => (props.type === 'outage' ? '#D2211D' : '#00BE14')};
  border: 1px solid
    ${props => (props.type === 'outage' ? '#D2211D' : '#00BE14')};
`;

export const Tooltip = styled.div.attrs<{ x: number; y: number }>(props => ({
  style: {
    left: `${props.x + 10}px`,
    top: `${props.y + 10}px`,
  },
}))<{ x: number; y: number }>`
  position: fixed;
  background-color: ${({ theme }) =>
    theme.title === 'dark' ? theme.colors.background : '#ffffff'};
  box-shadow: 0 2px 8px
    ${({ theme }) =>
      theme.title === 'dark' ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0.15)'};
  color: ${({ theme }) => theme.colors.text};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 4px;
  padding: 12px;
  z-index: 50;
  width: auto;
  max-width: 400px;
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
  pointer-events: auto;

  /* Estilização da scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) =>
      theme.title === 'dark' ? theme.colors.background1 : '#f1f1f1'};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => (theme.title === 'dark' ? '#555' : '#888')};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => (theme.title === 'dark' ? '#777' : '#555')};
  }
`;

export const TooltipAlarmInfo = styled.div`
  font-weight: 500;
  margin-bottom: 8px;
  color: #1890ff;
`;

export const TooltipDate = styled.div`
  font-weight: 500;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.text};
`;

export const TooltipEvent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
`;

export const TooltipEventIcon = styled.div`
  .anticon-close-circle {
    background-color: transparent !important;
  }
`;

export const TooltipEventContent = styled.div``;

export const TooltipEventTitle = styled.div`
  color: ${({ theme }) => theme.colors.text};
  font-weight: 500;
`;

export const TooltipEventDate = styled.div`
  font-size: 14px;
  color: ${({ theme }) =>
    theme.title === 'dark' ? theme.colors.text : '#8c8c8c'};
`;

export const TooltipNoEvents = styled.div`
  color: ${({ theme }) =>
    theme.title === 'dark' ? theme.colors.text : '#8c8c8c'};
`;

export const CircleButton = styled.button`
  height: 32px;
  width: 32px;
  padding: 0;
  border-radius: 50%;
`;
